module.exports = __webpack_public_path__ + "img/PR6.98b0f248.png";